import { useNavigate } from "react-router-dom";

export function generateNonce(length: number = 10): string {
    const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return result;
}

export function setCookie(name: string, value: string, days: number, path = '/', domain = window.location.hostname): void {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=${path}; Secure; SameSite=None`;
}

export function getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() ?? null;
    return null;
}

export function buildAuthUrl(base: string, params: { [key: string]: string }): string {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
        queryParams.set(key, params[key]);
    });
    return `${base}?${queryParams.toString()}`;
}

export const uncheckedRoutes = ['/auth/deny']

export const getIsExternal = (): boolean => {
    const sessionKey = 'userProfile'
    const userProfileStr = sessionStorage.getItem(sessionKey) as string;
    const userProfileObj = JSON.parse(userProfileStr) || {};
    const isExternal = userProfileObj.isExternal;
    return isExternal === true;
};


export const genVerifiedURL = (localBaseURL: string, providedFullURL: string): string => {
    const errorRoute = `${localBaseURL}/access-error`

    const authorizedRoutes = JSON.parse(sessionStorage.getItem('authorizedRoutes') || '[]') as string[]
    const allAccessible = ['/', ...uncheckedRoutes, ...authorizedRoutes];
    try {
        let parsedFullPathName = '/'
        const parsedURL = new URL(providedFullURL);
        const { pathname, search } = parsedURL
        if (!(['/', '/vision'].includes(pathname))) {
            parsedFullPathName = pathname.split('/vision/')[1] // example /beacon/importOperations
        }
        const featureHome = `/${parsedFullPathName.split('/')[0]}`  // extract /beacon from the above example
        const verifiedURL = providedFullURL.indexOf(localBaseURL) === 0;
        const verifiedAccess = allAccessible.includes(featureHome)
        if (!verifiedURL || !verifiedAccess) {
            return errorRoute
        }
        const sanitizedStr = `${localBaseURL}${pathname}${search}`
        return sanitizedStr
    } catch (error) {
        console.log('error while matching authorized routes for user', error)
        return errorRoute
    }

}


export const isValidURL = (url: string): boolean => {
    try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.origin === window.location.origin
    } catch (error) {
        return false
    }
}

export const validateState = (state: string): boolean => {
    const checkStr = localStorage.getItem('rdmVrf');
    return checkStr === state;
}

export const extractPathName = (urlString: string) => {
    const location = new URL(urlString)
    return location.pathname
}

export const isUserSessionActive = () => {
    const currentTime = new Date().getTime();
    const sessionExpiresAt = Number(sessionStorage.getItem('viSsnExp') || '0');
    return (currentTime < sessionExpiresAt) && !!sessionStorage.getItem('userSession');
}

export const removeLeadingSlash = (str: string): string => {
    return str.startsWith('/') ? str.slice(1) : str;
};

export const addLeadingVision = (pathStr: string): string => {
    return `vision/${pathStr}`.replace('//', '/')
};

export const handleNavigationEvent = (navigate: ReturnType<typeof useNavigate>) => {
    const handleEvent = (event: CustomEvent<{ path: string; params?: Record<string, string | number | null> }>) => {
        const { path, params } = event.detail;

        console.log('event triggered', { path, params })

        // Sanitize path to prevent open redirect (CWE-601) — event.detail is externally controlled
        // Use URL constructor to extract a clean, same-origin pathname only
        let safePath: string;
        try {
            const url = new URL(path, window.location.origin);
            if (url.origin !== window.location.origin) return;
            safePath = url.pathname;
        } catch {
            return;
        }

        // Construct the full path with query parameters
        const queryParams = new URLSearchParams(params as Record<string, string>).toString();
        const fullPath = queryParams ? `${safePath}?${queryParams}` : safePath;

        // Navigate to the constructed path
        navigate(fullPath);
    };

    // Add event listener for custom navigation events
    window.addEventListener('remoteNavigate', handleEvent as EventListener);

    // Cleanup the event listener when the component unmounts
    return () => {
        window.removeEventListener('remoteNavigate', handleEvent as EventListener);
    };
};